import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "../common/Logo";
import { StopFreeSaleExportTable } from "./StopFreeSaleExportTable";
import { enmStopFreeSale } from "../../models/enums/StopFreeSale";
import dayjs from "dayjs";
import { mdlStopFreeSaleExport } from "../../models/domain/StopFreeSaleExport";
import { StopFreeSaleExportTemplate } from "./StopFreeSaleExportTemplate";
import { Button, Col, Flex, Form, Input, Row, Space, Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import { mdlStopFreeSaleMessageUpdateRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleMessageUpdateRequest";
import { mdlStopFreeSaleEmailRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleEmailRequest";
import { nanoid } from "@reduxjs/toolkit";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";

export type StopFreeSaleExportEmailProps = {
    dataSource?: mdlStopFreeSaleExport;
    fnAgencyMailPreview?: Function;
    defaultTo?: string;
    defaultSubject?: string;
    visibleTo?: boolean;
    visibleSubject?: boolean;
    detail?: mdlStopFreeSaleDetail[];
    message?: mdlStopFreeSaleMessage;
    stopFreeSaleType?: enmStopFreeSale;
    showSendButton?: boolean;
    closePopup?: Function;
}

export const StopFreeSaleExportEmail = memo(function StopFreeSaleExportEmail(props: StopFreeSaleExportEmailProps) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    useEffect(() => {
    }, []);
    const { mutateAsync: saveStopFreeSaleMessage, isLoading: mutateLoading, data: mutateData } = useMutation(
        (data: mdlStopFreeSaleEmailRequest) => StopFreeSaleService.SendEmail({...data, id: props.dataSource?.id}),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data:any, variables, context) {
                if (data.header && data.header.success) {
                    if(data.body.isSuccessful == true){

                        toast.success(t("common.success"));
                        props.closePopup && props.closePopup();
                    }else{
                        toast.error(data.body.message.toString());
                    }
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            }
        }
    );

    return (
        <>
            <Form
                form={form}
                key={nanoid()}
                name="agency-form"
                layout="vertical"
                onFinish={async (values) => await saveStopFreeSaleMessage(values)}
                autoComplete="off"
            >
                    <Spin spinning={mutateLoading}>
                    <Row gutter={24}>
                    <Col span={24}>
                        <Form.Item<mdlStopFreeSaleEmailRequest>
                            className={props.visibleTo != undefined && !props.visibleTo  && !props.visibleTo ? "d-none" : ""}
                            label={t("stopFreeSale.to")}
                            name={["to"]}
                            rules={[{ required: true, message: t("common.required") }]}
                        >
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item<mdlStopFreeSaleEmailRequest>
                            className={props.visibleSubject != undefined && !props.visibleSubject ? "d-none" : ""}
                            label={t("stopFreeSale.subject")}
                            name={["subject"]}
                            rules={[{ required: true, message: t("common.required") }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <StopFreeSaleExportTemplate stopFreeSaleType={props.stopFreeSaleType} fnAgencyMailPreview={props.fnAgencyMailPreview} dataSource={props.dataSource} detail={props.detail} message={props.message}/>
                    </Col>
                </Row>
                {props.showSendButton != false && <Row style={{ marginTop: "25px" }} justify={"end"}>
                    <Form.Item className="mb-0 my-0">
                        <Flex align={"center"} justify="flex-end">
                            <Space>
                                <Button type="primary" htmlType="submit">{t("common.send")}</Button>
                            </Space>
                        </Flex>
                        </Form.Item>
                    </Row>
                }
                </Spin>
            </Form>
        </>
    )
})